export type AvatarRole = 'dispatch' | 'tech'

export interface AvatarProps {
  initials: string
  /**
   * Role colour means role — dispatch and tech, each its own token
   * (--role-dispatch / --role-tech in tokens.css). Theme-dependent as of
   * task 2 (the header/account-menu repaint): gold/teal in the two Tossker
   * themes, the original pink/blue in the two Legacy themes. Omit for a
   * neutral avatar.
   */
  role?: AvatarRole
  /** Fill means activity: true = filled tint (typing), false = outline only (reading/idle). */
  active?: boolean
  size?: number
  title?: string
  className?: string
}

const ROLE_CLASSES: Record<AvatarRole, { active: string; idle: string }> = {
  dispatch: { active: 'bg-dispatch-subtle text-dispatch border-dispatch', idle: 'bg-transparent text-dispatch border-dispatch' },
  tech: {
    active: 'bg-role-tech-subtle text-role-tech border-role-tech',
    idle: 'bg-transparent text-role-tech border-role-tech',
  },
}

export function Avatar({ initials, role, active = false, size = 28, title, className = '' }: AvatarProps) {
  // Fix round 2 (finding 12): was `bg-elevated` — wrong slot for content
  // on a card (an avatar sits inside rows/headers, not above them).
  const roleClasses = role ? ROLE_CLASSES[role][active ? 'active' : 'idle'] : 'bg-sunken text-hi border-subtle'

  return (
    <span
      title={title}
      className={['inline-flex items-center justify-center rounded-full border font-semibold', roleClasses, className]
        .filter(Boolean)
        .join(' ')}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
    >
      {initials}
    </span>
  )
}
